module.exports = __webpack_public_path__ + "img/Radio button gray.1da3e429.svg";